import { BehaviorSubject } from 'rxjs';
import { BreakpointState } from '@angular/cdk/layout';
import { BreakpointsLib } from './const-system';

export const subBreakpointObserver = new BehaviorSubject<BreakpointState>(null);

export const getLayout = () => {
    return {
        mobile: subBreakpointObserver.value?.breakpoints[BreakpointsLib.MediumMobile] ||
            subBreakpointObserver.value?.breakpoints[BreakpointsLib.SmallMobile],
        tablet: subBreakpointObserver.value?.breakpoints[BreakpointsLib.SmallTablet] ||
            subBreakpointObserver.value?.breakpoints[BreakpointsLib.LargeTablet],
        desktop: subBreakpointObserver.value?.breakpoints[BreakpointsLib.SmallDesktop] ||
            subBreakpointObserver.value?.breakpoints[BreakpointsLib.LargeDesktop],
    }
}
